import React from "react";
import Nav from "./component/nav/Nav";


const App = () => {
  return (
    <>
      <Nav />
    </>
  );
};

export default App;
